type SelectedPackOptions = Record<string, { extension?: { duration?: { id?: string } } }>;

// Single source of truth for order.tariffId: the base duration's tariff, unless the
// currently active pack has an extension selected, in which case the extension's
// (alternative-tariff) duration id is used instead. Mirrors isBillboardSelected's
// accessor-injection pattern so it can be called with rootGetters, no store coupling.
export function getTariffId(
    getTransactionValue: (path: string) => unknown,
    getOrderValue: (path: string) => unknown
): string | null {
    const duration = getTransactionValue("transaction.duration");
    const selectedPackage = getOrderValue("order.visualizationOption");
    const packOptions = (getTransactionValue("optimizedEncoding.selectedPackOptions") || {}) as SelectedPackOptions;

    const packKey = typeof selectedPackage === "string" ? selectedPackage.toLowerCase() : "";
    const extensionDurationId = packKey ? packOptions[packKey]?.extension?.duration?.id : undefined;

    if (typeof extensionDurationId === "string" && extensionDurationId !== "") {
        return extensionDurationId;
    }

    return typeof duration === "string" && duration !== "" ? duration : null;
}
